<template>
  <div class="home">
    <SiderContent01 />
    <SiderContent03 />
    <SiderContent02 />
    <!-- <SiderContent04 /> -->
  </div>
</template>

<script>

import SiderContent01 from './siderContent01'
import SiderContent02 from './siderContent02'
import SiderContent03 from './siderContent03'
// import SiderContent04 from './siderContent04'
export default {
  name: 'home-index',
  components: {
    SiderContent01,
    SiderContent02,
    SiderContent03,
    // SiderContent04
  },
  data () {
    return {
    }
  }
}

</script>




// WEBPACK FOOTER //
// src/components/home/homeIndex/index.vue